import { FilterFn, Row, createColumnHelper } from '@tanstack/react-table';
import { SearchEntityInfoResponse } from 'modules/global/adapters/crpAPI';
import i18n from 'modules/global/config/i18n';
import { CSSProperties } from 'react';

const columnHelper = createColumnHelper<SearchEntityInfoResponse>();

const arrayFilter: FilterFn<SearchEntityInfoResponse> = (
  row: Row<SearchEntityInfoResponse>,
  columnId: string,
  filterValue: string
) => {
  const values: string[] = row.getValue(columnId);

  return values.some((value) => value.toLowerCase().includes(filterValue.toLowerCase()));
};

const wrapTextStyle: CSSProperties = {
  whiteSpace: 'pre-wrap', // preserves whitespace and wraps text
  wordWrap: 'break-word', // breaks long words
  overflowWrap: 'break-word', // breaks long words
};

const CompaniesColumns = [
  columnHelper.accessor('name', {
    cell: (info) => <div style={wrapTextStyle}>{info.getValue()}</div>,
    size: 250,
    header: () => i18n.t('glossary:name'),
    filterFn: 'includesString',
  }),
  columnHelper.accessor('nxtEntityId', {
    cell: (info) => <div style={wrapTextStyle}>{info.getValue()}</div>,
    header: () => i18n.t('glossary:nxtEntityId'),
    filterFn: 'includesString',
  }),
  columnHelper.accessor('apcsCode', {
    cell: (info) => <div style={wrapTextStyle}>{info.getValue()}</div>,
    header: () => i18n.t('glossary:apcsCode'),
    size: 140,
    filterFn: 'includesString',
  }),
  columnHelper.accessor('eori', {
    cell: (info) => <div style={wrapTextStyle}>{info.getValue()}</div>,
    header: () => i18n.t('glossary:eori'),
    size: 140,
    filterFn: 'includesString',
  }),
  columnHelper.accessor('duns', {
    cell: (info) => <div style={wrapTextStyle}>{info.getValue()}</div>,
    header: () => i18n.t('glossary:duns'),
    size: 140,
    filterFn: 'includesString',
  }),
  columnHelper.accessor('vatNumber', {
    cell: (info) => <div style={wrapTextStyle}>{info.getValue()}</div>,
    header: () => i18n.t('glossary:vatNumber'),
    filterFn: 'includesString',
  }),
  columnHelper.accessor('roles', {
    cell: (info) => <div style={wrapTextStyle}>{info.getValue().join(', ')}</div>,
    size: 390,
    header: () => i18n.t('glossary:cpuRoles'),
    filterFn: arrayFilter,
  }),
];

export default CompaniesColumns;
